//
//
//
//
//
//
//
//
//

export default {
    name: 'button',
    data() {
      return {
        args: {
          type:"danger",
          size:"30px",
          width:"60px",
          height:"60px"
        }
      }
    }
};



// WEBPACK FOOTER //
// ./example/pages/fixed-button.vue